import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CANCELED_ERROR } from 'utils/constants';
import { GET_ALL_TYPE } from 'utils/serviceUrls';
import { axiosPrivateInstance } from 'libs/axios';
import { useAppDispatch } from 'hooks/stateHooks';
import { setMessage, setNotificationType, setShowNotification } from 'slices/roleModuleSlice';

const useGetAllType = () => {
	const dispatch = useAppDispatch();
	const { t } = useTranslation('serialNumber');

	const [allTypeData, setAllTypeData] = useState<any>([]);
	const [allTypeDataLoading, setAllTypeDataLoading] = useState<boolean>(true);

	useEffect(() => {
		const controller = new AbortController();
		const { signal } = controller;

		setAllTypeDataLoading(true);
		axiosPrivateInstance
			.post(GET_ALL_TYPE, {}, { signal })
			.then((response: any) => {
				if (response?.output) {
					setAllTypeData(response?.output);
				} else {
					dispatch(setMessage(t('SOMETHING_WENT_WRONG')));
					dispatch(setShowNotification(true));
					dispatch(setNotificationType('error'));
				}
			})
			.catch((error: any) => {
				if (error?.name === CANCELED_ERROR) {
					return;
				}
				dispatch(setMessage(t('SOMETHING_WENT_WRONG')));
				dispatch(setShowNotification(true));
				dispatch(setNotificationType('error'));
			})
			.finally(() => {
				setAllTypeDataLoading(false);
			});

		return () => controller.abort();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		allTypeData,
		allTypeDataLoading,
	};
};

export default useGetAllType;
